// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {
    Avatar, Stack,
    Tooltip
} from "@mui/material";

// App Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {getContractVocabularyList} from "../ContractClient";
import {changeContractDetailList} from "./contractDetailListSlice";
import Typography from "@mui/material/Typography";


// Main Function
export default function ContractVocabularyListDrawer() {


    // ****************** BEGIN STATES ****************************

    const [contractVocabularyList, setContractVocabularyList] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractId = useSelector((state) => state.contractDetailListSlc.value.contractId);
    const selectorContractName = useSelector((state) => state.contractDetailListSlc.value.contractName);
    const selectorVocabularyListDrawerState = useSelector((state) => state.contractDetailListSlc.value.vocabularyListDrawerState);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractVocabularyList = () =>
        getContractVocabularyList(selectorContractId)

            .then(data => {
                console.log("this as my response");
                console.log(data);
                setContractVocabularyList(data);
            });

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        fetchContractVocabularyList();
    }, [ useSelector((state) => state.contractDetailListSlc.value.vocabularyListDrawerState)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    function closeContractVocabularyListDrawer() {
        dispatchData(changeContractDetailList({id: 0, vocabularyListDrawerState: false}));
    };

    // ***************** END CONTROLS ***************************


    // ****************** BEGIN HANDLES *****************************

    const handleCSFList = (dataPointId) => {
        console.log("Here's the selected row data");
        dispatchData(changeContractDetailList({contractId: selectorContractId,
            dataPointId: dataPointId,
            csListDrawerState: false,
            csfListDrawerState: true,
            cdpListDrawerState: false,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: false,
            vocabularyListDrawerState: false,
            marketListDrawerState: false}));
        ;
    }

    const handleCDPList = (dataPointId) => {
        console.log("Here's the selected row data");
        dispatchData(changeContractDetailList({contractId: selectorContractId,
            dataPointId: dataPointId,
            csListDrawerState: false,
            csfListDrawerState: false,
            cdpListDrawerState: true,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: false,
            vocabularyListDrawerState: false,
            marketListDrawerState: false}));
        ;
    }
    const handleCDPVFList = (dataPointId) => {
        console.log("Here's the selected row data");
        dispatchData(changeContractDetailList({contractId: selectorContractId,
            dataPointId: dataPointId,
            csListDrawerState: false,
            csfListDrawerState: false,
            cdpListDrawerState: false,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: true,
            vocabularyListDrawerState: false,
            marketListDrawerState: false}));
        ;
    }

    // ****************** END HANDLES *****************************


    // ***************** BEGIN MISC ***************************

    const renderContractVocabularyList = contractVocabularyList => {
        if (contractVocabularyList.length <= 0) {
            return "No Data";
        }}

    // *************** END MISC *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = contractVocabularyList => [

        {
            field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            editable: false,
            width: 50,
            hide: true,
        },
        {
            field: 'dataPointId',
            headerName: 'DP ID',
            description: '',
            sortable: true,
            editable: false,
            width: 100,
            hide: false,
        },
        {
            field: 'dataPointName',
            headerName: 'Data Point',
            description: '',
            sortable: true,
            editable: false,
            width: 500,
            hide: false,
        },

        {
            field:  'csfCount',
            headerName: 'Section Filters',
            headerAlign: 'center',
            width: 120,
            renderCell: (contractVocabularyList) => {
                const count = contractVocabularyList.row.csfCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title={"Count of Section Filters using the Data Point."}
                                 onClick= {() => handleCSFList(contractVocabularyList.row.dataPointId)}>
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                bgcolor: "rgb(30,144,255)"
                            }}
                                    style={{cursor:'pointer'}}
                            >
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },

        {
            field:  'cdpCount',
            headerName:  'Contract Data Points',
            headerAlign: 'center',
            width: 150,
            renderCell: (contractVocabularyList) => {
                const count = contractVocabularyList.row.cdpCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title={"Count of Contract Data Points using the Data Point."}
                                 onClick= {() => handleCDPList(contractVocabularyList.row.dataPointId)}>
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                bgcolor: "rgb(30,144,255)"
                            }}
                                    style={{cursor:'pointer'}}
                            >
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
        {
            field:  'cdpvfCount',
            headerName: 'Value Filters',
            headerAlign: 'center',
            width: 150,
            renderCell: (contractVocabularyList) => {
                const count = contractVocabularyList.row.cdpvfCount;

                if (count === 0 || count === null || count === undefined) return "";

                // Calculate width based on digit count
                const digitCount = count.toString().length;
                const width = 20 + (digitCount - 1) * 10; // Start at 20, add 10px per extra digit

                return (
                    <Box sx={{
                        width: "100%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title={"Count of filters using the Data Point."}
                                 onClick= {() => handleCDPVFList(contractVocabularyList.row.dataPointId)}>
                            <Avatar variant="rounded" sx={{
                                height: 20,
                                width,
                                fontSize: 16,
                                bgcolor: "rgb(30,144,255)"
                            }}
                                    style={{cursor:'pointer'}}
                            >
                                {count}
                            </Avatar>
                        </Tooltip>
                    </Box>
                );
            }
        },
    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1100 },
                }}
                anchor='right'
                open={selectorVocabularyListDrawerState}
                initialState={{open: false}}
                onClose={closeContractVocabularyListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                    <h1 onClick={() => closeContractVocabularyListDrawer()}>Vocabulary List</h1>
                    <Stack direction="row" spacing={1}>
                        {/*<Typography component="span">id:</Typography>*/}
                        {/*<Typography component="span" fontWeight="bold">{selectorContractId}</Typography>*/}
                        {/*<Box sx={{ ml: 6 }} /> /!* Adds extra spacing before 'name:' *!/*/}
                        {/*<Typography component="span">name:</Typography>*/}
                        <Typography component="span" fontWeight="bold">{selectorContractName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"ContractVocabularyList"}
                    rows={contractVocabularyList}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(contractVocabularyList)}
                    density={"compact"}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    rowKey={contractVocabularyList => contractVocabularyList.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
